import { Strings } from "../../resources/i18n/i18n";

export const COLLECTION_EXPENSE_STATUS = [
  "APPLIED",
  "PAID",
  "PAYMENT_REVERTED",
  "PARTIALLY_REVERTED",
];

export const EXPENSE_HISTORY_COLUMNS = [
  {
    key: "createdAt",
    name: Strings("Date"),
    maxWidth: 200,
    minWidth: 200,
  },
  {
    key: "type",
    name: Strings("expenseType"),
    maxWidth: 200,
    minWidth: 200,
  },
  {
    key: "entryType",
    name: Strings("Status"),
    maxWidth: 180,
    minWidth: 180,
  },
  {
    key: "revertPercentage",
    name: Strings("percentage"),
    maxWidth: 150,
    minWidth: 150,
  },
  {
    key: "createdBy",
    name: Strings("CreatedBy"),
    maxWidth: 200,
    minWidth: 200,
  },
];
